<section class="mainTopBanner checker-banner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">文章改寫</h1>
                        <h2>提升寫作清晰度</h2>
                        <p>使用 Trinka 文章改寫工具，讓你的文字更通順明確。系統會提供建議，幫助你在保留原意的同時，創造出連貫且易懂的改寫句子。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <div id="online-paraphraser" class="carousel slide" data-ride="carousel">
                            <div class="row">
                                <div class="col-12">
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src="/assets/images/paraphraser/online_paraphrase_banner.svg" width="611" height="339" alt="paraphraser" class="img-fluid h-auto" />
                                        </div>
                                        <div class="carousel-item">
                                            <img src="/assets/images/paraphraser/online_paraphrase_spanish.svg" width="611" height="339" alt="paraphraser spanish" class="img-fluid h-auto" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="cs-dots">
                                        <h6 class="text-start text-left">支援語言</h6>
                                        <div class="carousel-indicators">
                                            <button type="button" data-target="#online-paraphraser" data-slide-to="0" class="active">英文</button>
                                            <button type="button" data-target="#online-paraphraser" data-slide-to="1">西班牙文</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/online-phraphraser-video-banner.webp" width="800" height="450" alt="paraphraser" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「文章改寫」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p>還有其他問題嗎？歡迎瀏覽我們的常見問答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pb-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>文章改寫主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-70">快來認識 Trinka 的超強改寫功能，操作簡單，讓你輕鬆又快速完成句子改寫</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>加速句子改寫流程</h3>
                    <p>Trinka 將改寫工具無縫整合到現有介面中，讓你在熟悉的環境下輕鬆使用。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image list-wrapper-video">
                    <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/paraphraser/videos/speed-up-paraphrase.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>多重改寫選項任你挑</h3>
                    <p>Trinka 提供多種改寫版本，幫助你提升內容連貫性。 </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image list-wrapper-video">
                    <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/paraphraser/videos/aternatives.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>輕鬆替換改寫文字</h3>
                    <p>只需幾個點擊，就能用改寫後的文字取代原文，自動插入文件中，快速又方便。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image list-wrapper-video">
                    <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/paraphraser/videos/Replaced-Paraphrase.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>審閱修改並完成稿件</h3>
                    <p>Trinka 會以「修訂模式」顯示改寫內容，讓你清楚看到所有變更，輕鬆確認並完成文件。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image list-wrapper-video">
                    <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/paraphraser/videos/show-revisions.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<app-paraphrasing-modes></app-paraphrasing-modes>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>為什麼選擇 Trinka 文章改寫工具？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/paraphraser/icon1.svg" loading="lazy" decoding="async" alt="Improve Efficiency">
                    <h3>提升效率 </h3>
                    <p>Trinka 改寫工具直接整合於編輯器中，讓你在同一平台完成改寫工作，節省寶貴時間，提高工作效率。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/paraphraser/icon2.svg" loading="lazy" decoding="async" alt="Paraphrase Effectively">
                    <h3>有效改寫</h3>
                    <p>Trinka 提供多種改寫模式，讓你全面掌控最終內容，輕鬆選擇符合你語氣與風格的改寫版本。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/paraphraser/icon3.svg" loading="lazy" decoding="async" alt="Improve clarity">
                    <h3>提升清晰度</h3>
                    <p>改寫同時優化句子清晰度與連貫性，Trinka 會自動檢查文法、拼字及結構問題，讓你的文字更專業流暢。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinka 文章改寫工具，無限次數隨你用！</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<app-security-section></app-security-section>

<section class="allAboutTrinkaCredit list-wrapper-style-2 section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <span class="trinka-sub-title mx-auto">企業用戶專屬</span>
                    <h2 class="mt-3">Trinka 文章改寫工具 API</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>將 Trinka 的文章改寫功能直接整合到您的組織工作流程中，提升內容的清晰度與表達品質。</p>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="api_img text-center">
                    <img src="/assets/images/paraphraser/API.svg" width="344" height="344" class="img-fluid" alt="paraphraser api" />
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-4 col-md-4">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <h3>快速且具擴展性</h3>
                            <p>Trinka 的快速改寫功能，幫助提升團隊內容產出效率，並隨組織成長靈活擴充。</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <h3>資料安全</h3>
                            <p>所有資料都在高度加密的環境下，絕對安全。不管你處理的文字量有多大，你的內容都會保持機密，完全不用擔心外洩問題。</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <h3>客製化服務</h3>
                            <p>可以依照組織的需求，自訂潤稿的程度和替換選項的數量，確保所有文件風格一致。輕輕鬆鬆就能讓內容清晰又統一！</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faqQuestionAnwser section-pd pt-0" #target>
    <div class="trinka_container container">
       <div class="row justify-content-center">
          <div class="col-lg-8 col-md-10">
             <div class="trinka-title text-center">
                <h2>常見問答</h2>
                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
             </div>
          </div>
       </div>
       <div class="faqQuestionsList">
          <div class="accordion" id="faq">
             <div class="row">
                <div class="col-lg-6">
                   <div class="faqContainer">
                      <div class="card">
                         <div class="card-header" id="QuestionOne">
                            <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                Trinka 的文章改寫工具是免費的嗎？</a>
                         </div>
                         <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                            <div class="card-body">
                               <p>是的，您可以免費使用 Trinka 進行內容改寫。不過基本用戶方案每月改寫字數上限為 5000 字，且同時包含 5000 字的文法檢查額度。若您需要無限制的改寫使用權，建議升級至高級用戶方案，享有不限次數、無字數限制的完整功能。
                                趕快立即升級！</p>
                            </div>
                         </div>
                      </div>
                      <div class="card">
                         <div class="card-header" id="QuestionTwo">
                            <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                               aria-controls="QuestionTwoContent">
                               使用改寫文章改寫工具時，我的內容安全嗎？ </a>
                         </div>
                         <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                            <div class="card-body">
                               <p>放心，Trinka 採用最高等級的資料安全標準，並遵守多項合規規範，確保您的資料完全保密與安全。 </p>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="col-lg-6">
                   <div class="faqContainer">
                      <div class="card">
                         <div class="card-header" id="QuestionThree">
                            <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                               aria-controls="QuestionThreeContent">
                               我可以自訂改寫程度以符合我的寫作風格嗎？
                            </a>
                         </div>
                         <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                            <div class="card-body">
                               <p>當然可以！您能自由選擇不同的改寫模式，調整語氣與風格，還能從多個改寫版本中挑選，確保內容符合您的需求與喜好。</p>
                            </div>
                         </div>
                      </div>
                      <div class="card">
                         <div class="card-header" id="QuestionFour">
                            <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                               aria-controls="QuestionFourContent">
                               文章改寫工具能處理技術性或專業內容嗎？
                            </a>
                         </div>
                         <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                            <div class="card-body">
                               <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                               <p>Trinka 專精於學術和技術寫作，這讓它成為處理技術性或專業內容的首選工具。我們的工具專為這類文件量身打造，能確保內容的準確性和專業性。</p>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/qF_9Al4NHIY"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>